import React from "react";
import './VerticalTabs.css'

const VerticalTabs = ({ menus, activeMenu, setActiveMenu, placement, alignment, spacing}) => {
    const css_classes = "vertical-tab vt-aligned-" + alignment + " vt-placed-" + placement;

    const activate = (slug) => {
        return activeMenu === slug ? css_classes + " active" : css_classes;
    };

    return (
        <div>
            <div className={"vertical-tabs" + " vertical-tabs-" + placement} style={{rowGap: spacing}}>
                {menus.map((c) => (
                    <button key={c.slug} onClick={() => setActiveMenu(c.slug)}
                        className={activate(c.slug)}>
                        {c.menu_text}
                    </button>
                ))}
            </div>           
        </div>
    );
};

export default VerticalTabs;
